module.exports = "/images/Luxembourg.png?8b7788208618dfa4ec208a40a6394819";